<template>
	<modal @close="close">
		<div class="item-modal">
			<div class="media">
				<img v-if="img" :src="media.url"/>
				<video v-else-if="video" :src="media.url" controls autoplay muted/>
				<div v-else class="icon" v-html="documentIcon"/>
			</div>
			<div class="text">
				<div class="name" v-text="name"/>
				&nbsp;
				<div class="date" v-text="date"/>
			</div>
			<a class="download" :href="download_url">
				<div class="icon" v-html="require('@/assets/icons/download-solid.svg')"/>
			</a>
		</div>
	</modal>
</template>

<script>
import {date} from "@/modules/utils";
import modal from "@/components/modal.vue";

export default {
	components: {modal},
	props: {
		id: {type: Number, required: true},
		img: {type: Boolean, required: true},
		video: {type: Boolean, required: true},
		name: {type: String, required: true},
		media: {type: Object, required: true},
		updated_at: {type: Number, required: true},
		download_url: {type: String, required: true}
	},
	computed: {
		date: (t) => `— ${date(t.updated_at).string}`,
		documentIcon() {
			const m = this.media.mime_type;
			return m.endsWith("pdf") ? require('@/assets/icons/file-pdf-regular.svg') : require('@/assets/icons/file-archive-regular.svg');
		}
	},
	methods: {
		close() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss" scoped>
.item-modal {
	padding: 30px 0;
	display: flex;
	align-items: center;
	flex-direction: column;

	@include res(mobile) {
		padding: 0;
	}

	.media {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 527px;
		height: 471px;
		@include res(mobile) {
			width: 100%;
			max-width: 527px;
			height: auto;
		}

		img {
			max-width: 100%;
			max-height: 100%;
			display: block;
		}

		video {
			width: 100%;
			height: auto;
			display: block;
		}

		.icon {
			/deep/ svg {
				height: 400px;
				width: auto;
				@include res(mobile) {
					height: 200px;
				}
			}
		}
	}

	.text {
		display: flex;
		font-size: 14px;
		padding-top: 36px;

		@include res(mobile) {
			flex-direction: column;
			text-align: center;
		}

		.name {
			font-weight: 600;
		}
	}

	.download {
		position: absolute;
		left: 24px;
		bottom: 24px;

		/deep/ svg {
			$s: 22px;
			width: $s;
			height: $s;

			path {
				fill: #979797;
			}
		}
	}
}
</style>
